import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';  // 👈 Importa el hook

/**
 * TurneroLogin - Premium Form for existing admins
 */
const TurneroLogin = ({ ipserv, onToggle, onForgot }) => {

    const navigate = useNavigate();  // 👈 Llama al hook
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        Email: '',
        Password: ''
    });

    const handleLogin = (e) => {
        e.preventDefault();
        setLoading(true);

        const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/';

        request.Post(API_BASE + 'turnero/login', formData, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Bienvenido a TuFila' });
                localStorage.setItem('tufila_admin', JSON.stringify(r.profile));
                localStorage.setItem('tufila_token', r.token);
                // Route based on role
                if (r.profile?.AdminRole === 'SUPERADMIN') {
                    window.location.href = '/tufilaapp/Turnero/SuperAdmin';
                } else {
                    window.location.href = '/tufilaapp/';
                }
            } else {
                Notify({ type: 'fail', text: r.message || 'Credenciales incorrectas' });
            }
            setLoading(false);
        }, 'json', err => {
            console.error("Error detallado:", err);
            Notify({ type: 'fail', text: err.msg || 'Error de conexión' });
            setLoading(false);
        });
    };

    return (
        <div className="w-100">
            <h1 className="auth-title">Bienvenido</h1>
            <p className="auth-subtitle">Ingresa tus credenciales para acceder al panel.</p>

            <form onSubmit={handleLogin}>
                <div className="auth-input-group">
                    <input
                        type="email"
                        className="auth-input"
                        placeholder="Email corporativo"
                        value={formData.Email}
                        onChange={e => setFormData({ ...formData, Email: e.target.value })}
                        required
                    />
                    <FontAwesomeIcon icon={faEnvelope} className="auth-input-icon" />
                </div>

                <div className="auth-input-group">
                    <input
                        type="password"
                        className="auth-input"
                        placeholder="Contraseña"
                        value={formData.Password}
                        onChange={e => setFormData({ ...formData, Password: e.target.value })}
                        required
                    />
                    <FontAwesomeIcon icon={faLock} className="auth-input-icon" />
                </div>

                <div className="d-flex justify-content-end mb-4">
                    <button
                        type="button"
                        className="btn btn-link p-0 text-white-50 small text-decoration-none auth-forgot-link"
                        onClick={onForgot}
                        style={{ fontSize: '0.85rem' }}
                    >
                        ¿Olvidaste tu contraseña?
                    </button>
                </div>

                <button type="submit" className="auth-btn-primary mb-4" disabled={loading}>
                    {loading ? <Spinner size="sm" animation="border" /> : (
                        <><FontAwesomeIcon icon={faSignInAlt} /> Entrar al sistema</>
                    )}
                </button>

                <div className="text-center">
                    <p className="text-muted small mb-1">¿No tienes una cuenta aún?</p>
                    <button type="button" className="btn btn-link text-primary font-weight-bold p-0 text-decoration-none" onClick={onToggle}>
                        Regístrate gratis
                    </button>
                </div>
            </form>
        </div>
    );
};

export default TurneroLogin;
